export const GET_COMPANIA = 'GET_COMPANIA';
export const LOADING_COMPANIA = 'LOADING_COMPANIA';